// removed by extract-text-webpack-plugin
module.exports = {"info":"_365-"};


//////////////////
// WEBPACK FOOTER
// ./~/@pickle/pickle-shared/src/features/Auth/ConfirmationCodeForm/ConfirmationCodeForm.scss
// module id = HpAY
// module chunks = 0